import React, { forwardRef } from 'react';
import styles from './Input.module.scss';

const Input = forwardRef(({
  type = 'text',
  value,
  onChange,
  placeholder = '',
  id,
  name,
  label,
  className = '',
  disabled = false,
  required = false,
  autoComplete,
  maxLength,
  minLength,
  pattern,
  size,
  spellCheck,
  onFocus,
  onBlur,
  ...props
}, ref) => {
  // Generate an ID if none is provided
  const inputId = id || `input-${name || label?.replace(/\s+/g, '-').toLowerCase() || Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className={`${styles.inputContainer} ${className} ${disabled ? styles.disabled : ''}`}>
      {label && (
        <label 
          htmlFor={inputId}
          className={styles.label}
        >
          {label}{required && <span className={styles.required}>*</span>}
        </label>
      )}
      
      <input
        ref={ref}
        id={inputId}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={styles.input}
        name={name}
        autoComplete={autoComplete}
        maxLength={maxLength}
        minLength={minLength}
        pattern={pattern}
        size={size}
        spellCheck={spellCheck}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-required={required}
        {...props}
      />
    </div>
  );
});

Input.displayName = 'Input';

export default Input; 